import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Home from "@/pages/Home";
import Invoices from "@/pages/Invoices";
import Billing from "@/pages/Billing";
import OrdersShipments from "@/pages/OrdersShipments";
import Claims from "@/pages/Claims";
import Returns from "@/pages/Returns";
import Reports from "@/pages/Reports";
import Support from "@/pages/Support";
import Documents from "@/pages/Documents";
import Inventory from "@/pages/Inventory";
import Delivery from "@/pages/Delivery";
import Admin from "@/pages/Admin";
import OpsLayoutPreview from "@/pages/OpsLayoutPreview";
import Training from "@/pages/Training";
import ReceivingStation from "@/pages/ReceivingStation";
import ReceivingInventoryStation from "@/pages/ReceivingInventoryStation";
import MoveStock from "@/pages/MoveStock";
import Settings from "@/pages/Settings";
import PendingApproval from "@/pages/PendingApproval";
import AcceptInvite from "@/pages/AcceptInvite";
import ResetPassword from "@/pages/ResetPassword";
import Gallery from "@/pages/Gallery";
import Onboarding from "@/pages/Onboarding";
import SalesFlyer from "@/pages/SalesFlyer";
import PlatformShowcase from "@/pages/PlatformShowcase";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/for-3pls" element={<SalesFlyer />} />
            <Route path="/platform" element={<PlatformShowcase />} />
            <Route path="/register" element={<Register />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/gallery" element={<ProtectedRoute requireStaff><Gallery /></ProtectedRoute>} />
            <Route
              path="/receiving"
              element={
                <ProtectedRoute requireStaff>
                  <ReceivingStation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/receiving-inventory"
              element={
                <ProtectedRoute requireStaff>
                  <ReceivingInventoryStation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/move-stock"
              element={
                <ProtectedRoute requireStaff>
                  <MoveStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pending"
              element={
                <ProtectedRoute>
                  <PendingApproval />
                </ProtectedRoute>
              }
            />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} />
              <Route path="welcome" element={<Onboarding />} />
              <Route path="invoices" element={<ProtectedRoute module="invoices"><Invoices /></ProtectedRoute>} />
              <Route path="billing" element={<ProtectedRoute module="billing"><Billing /></ProtectedRoute>} />
              <Route path="orders-shipments" element={<ProtectedRoute module="orders"><OrdersShipments /></ProtectedRoute>} />
              <Route path="delivery" element={<ProtectedRoute module="delivery"><Delivery /></ProtectedRoute>} />
              <Route path="claims" element={<ProtectedRoute module="claims"><Claims /></ProtectedRoute>} />
              <Route path="returns" element={<ProtectedRoute module="returns"><Returns /></ProtectedRoute>} />
              <Route path="inventory" element={<ProtectedRoute module="inventory"><Inventory /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute module="reports"><Reports /></ProtectedRoute>} />
              <Route path="support" element={<Support />} />
              <Route path="documents" element={<ProtectedRoute module="documents"><Documents /></ProtectedRoute>} />
              <Route path="settings" element={<Settings />} />
              <Route
                path="admin"
                element={
                  <ProtectedRoute requireStaff>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="ops-layout"
                element={
                  <ProtectedRoute requireStaff>
                    <OpsLayoutPreview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="training"
                element={
                  <ProtectedRoute requireStaff>
                    <Training />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
